import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../components/mensajes";
import { Loader, Dimmer } from "semantic-ui-react";
import useTable from "../components/useTable";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import axios from "axios";
import { formatMoneda } from "../util/varios";

const CatalogoProductoExistencia = (props) => {
  let op = require("../../public/modulos/datos");
  let token = sessionStorage.getItem("jwtToken");
  const btnAcepta = useRef();
  const btnCancela = useRef();
  const txtBuscar = useRef();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [values, setValues] = useState({
    idproducto: "",
    nombre: "",
    idalmacen: "",
  });
  const [itemSelect, setItemSelect] = useState(-1);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const headCells = [
    { label: "CODIGO", textAlign: "center" },
    { label: "NOMBRE", textAlign: "center" },
    { label: "ALMACEN", textAlign: "center" },
    { label: "EXISTENCIA", textAlign: "center" },
  ];

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              x.idproducto.includes(target.value) ||
              x.codigo.toLowerCase().includes(target.value.toLowerCase()) ||
              x.nombre.toLowerCase().includes(target.value.toLowerCase()) ||
              x.descripcion
                .toLowerCase()
                .includes(target.value.toLowerCase()) ||
              formatMoneda(
                x.cantidad.toString().replace(",", "").replace(".", ","),
                ",",
                ".",
                2
              )
                .toLowerCase()
                .includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  const seleccionarRegistros = () => {
    let endpoint = `${op.conexion}/api/inventario/productoexisselectubi?idalmacen=${props.idalmacen}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            setRecords(response.data);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const blanquear = () => {
    setItemSelect("");
    setActivate(false);
    setRecords([]);
    setValues({
      idproducto: "",
      nombre: "",
      idalmacen: "",
    });
    setFilterFn({
      fn: (items) => {
        return items;
      },
    });
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancelar();
  };

  const seleccionarProducto = () => {
    props.onHideAceptaCatalogo(values);
  };

  const seleccionarFila = (item) => (e) => {
    e.preventDefault();

    setValues({
      idproducto: item.idproducto,
      codigo: item.codigo,
      nombre: item.nombre,
      idalmacen: item.idalmacen,
    });
    btnAcepta.current.focus();
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        blanquear();
        seleccionarRegistros();
        txtBuscar.current.focus();
      }}
    >
      <Modal.Header className="azulGradiant2 header-modal">
        <div className="fw-bold text-light">
          <h3>Seleccionar Productos</h3>
        </div>
        <button
          ref={btnCancela}
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <Mensaje
          mensaje={mensaje}
          onHide={() =>
            setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
        />
        <Dimmer active={activate} inverted>
          <Loader inverted>Cargando...</Loader>
        </Dimmer>
        <div className="col-md-12" style={{ marginBottom: "10px" }}>
          <div className="row">
            <div className="input-group col-md-8 input-group-sm mb-3">
              <input
                type="text"
                onChange={handleSearch}
                className="form-control border-azul border-2 text-uppercase"
                ref={txtBuscar}
              />
              <button
                className="btn btn-info"
                style={{ pointerEvents: "none" }}
              >
                <i className="fa fa-search"></i>
              </button>
            </div>
          </div>
        </div>
        <div className="col-md-12" style={{ margin: "auto" }}>
          <TblContainer>
            <TblHead />

            <TableBody>
              {records &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <TableRow
                    key={index}
                    style={{
                      padding: "0",
                      cursor: "pointer",
                      background:
                        values.idproducto + values.idalmacen ===
                        item.idproducto + item.idalmacen
                          ? "lightskyblue"
                          : "white",
                    }}
                    onClick={seleccionarFila(item)}
                  >
                    <TableCell className="py-2 text-center">
                      {item.codigo}
                    </TableCell>
                    <TableCell className="py-2 text-start">
                      {item.nombre}
                    </TableCell>
                    <TableCell className="py-2 text-start">
                      {item.descripcion}
                    </TableCell>
                    <TableCell className="py-2 text-right">
                      {formatMoneda(
                        item.cantidad
                          .toString()
                          .replace(",", "")
                          .replace(".", ","),
                        ",",
                        ".",
                        2
                      )}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </TblContainer>
          <TblPagination />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          ref={btnAcepta}
          className="btn btn-sm btn-success rounded-pill"
          onClick={seleccionarProducto}
        >
          <i className="fas fa-check-circle"> Aceptar</i>{" "}
        </button>
        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-sm btn-danger rounded-pill"
        >
          <i className="fas fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default CatalogoProductoExistencia;



// WEBPACK FOOTER //
// ./src/catalogos/catalogoProductoExistencia.js